import { useState } from 'react';

import { faCopy } from '@fortawesome/pro-light-svg-icons';
import { useGetAgeHours } from 'queries';
import { useTranslation } from 'react-i18next';

import { AGE_HOURS } from 'RestAPIs/endpoints';
import { useDeleteById } from 'RestAPIs/useDeleteById';

import TableCRUDLayout, {
  TableCRUDLayoutHandlers
} from 'components/shared/CRUD/TableCRUDLayout';

import CreateEditAgeHours from './components/CreateEditAgeHours';

import useColumnDefinitions from './hooks/useColumnDefinitions';

const AgeHours = () => {
  const { t } = useTranslation();
  const { data, isFetching } = useGetAgeHours();
  const columnDefinitions = useColumnDefinitions();
  const [isCopied, setIsCopied] = useState(false);

  const handleClearCopied = () => {
    setIsCopied(false);
  };

  const handleCopyClick = (id, row, props: TableCRUDLayoutHandlers) => {
    setIsCopied(true);
    if (props.handleEditClick) {
      props.handleEditClick(id, row);
    }
  };

  const { mutate: handleDeleteClick } = useDeleteById(AGE_HOURS, ['ageHours']);

  return (
    <TableCRUDLayout
      FormComponent={(props) => (
        <CreateEditAgeHours {...props} isCopied={isCopied} />
      )}
      rows={data}
      loading={isFetching}
      columns={columnDefinitions}
      getRowId={(row) => row.agelistId}
      onDeleteClick={(id) => handleDeleteClick(id)}
      customActions={[
        {
          tooltipTitle: t('copy'),
          icon: faCopy,
          onClick: handleCopyClick
        }
      ]}
      confirmationTitle={t('ageHours.deleteAgeHourDialog.title')}
      confirmationBody={t('ageHours.deleteAgeHourDialog.body')}
      onClose={handleClearCopied}
    />
  );
};

export default AgeHours;
